import { EntityTypeEnum } from 'api'
import { flatMap } from 'lodash'
import { createSelector } from '@reduxjs/toolkit'
import { createAuthorisedUserSelector } from 'selectors/connectionSelectors'
import { mainRoutes } from './mainRoutes'
import { buildPermissionedRoutes, flattenRoutes } from './routeConfig'

const permissionedRoutesActiveEntitySubscriptionsSelector = createSelector(createAuthorisedUserSelector(), authorisedUser => {
  const flattenedPermissionedRoutes = flattenRoutes(buildPermissionedRoutes(mainRoutes, authorisedUser.permissions))

  return [...new Set(flatMap(flattenedPermissionedRoutes, route => route.activeEntitySubscriptions))]
})

export const permissionedRoutesHaveEntityTypeSelector = createSelector(
  permissionedRoutesActiveEntitySubscriptionsSelector,
  permissionedRoutesActiveEntitySubscriptions => (entityType: EntityTypeEnum) =>
    permissionedRoutesActiveEntitySubscriptions.includes(entityType)
)
